/**
 * MODULE: _shared/frontend/lib/frontend/hooks/useMobileShellActive.ts
 * PURPOSE: Reactive mobile-shell flag (viewport + touch) without requiring React context.
 * PUBLIC_API: useMobileShellActive
 * SIDE_EFFECTS: matchMedia + resize listeners
 * AGENT_SAFETY: SAFE
 */

import { useEffect, useState } from 'react';

import {
  MOBILE_SHELL_MEDIA_QUERIES,
  readMobileShellActive,
} from '../mobile/mobileShellDetection';

export function useMobileShellActive(): boolean {
  const [active, setActive] = useState(readMobileShellActive);

  useEffect(() => {
    const refresh = () => setActive(readMobileShellActive());
    refresh();

    const mediaLists = MOBILE_SHELL_MEDIA_QUERIES.map((query) => window.matchMedia(query));
    for (const mq of mediaLists) {
      mq.addEventListener('change', refresh);
    }
    window.addEventListener('resize', refresh, { passive: true });
    window.addEventListener('orientationchange', refresh);

    return () => {
      for (const mq of mediaLists) {
        mq.removeEventListener('change', refresh);
      }
      window.removeEventListener('resize', refresh);
      window.removeEventListener('orientationchange', refresh);
    };
  }, []);

  return active;
}
